'use strict';

import { legacyDateTimeRegexWhitelist, legacyDateTimeWhitelist } from './date-time-inteceptor.whitelists';

angular
    .module('shared.services.dateTimeInterceptor', [])
    .service('dateTimeInterceptor', [
        '$filter',
        'dateTextService',
        function ($filter, dateTextService) {
            var whitelist = Object.assign({}, legacyDateTimeWhitelist);

            // Apply whitelist for Angular12 app
            if (window.EveryBuddy.IsAngular12) {
                for (const key in whitelist) {
                    whitelist[window.EveryBuddy.WebAPI + key] = whitelist[key];
                }
            }

            var regexWhitelist = legacyDateTimeRegexWhitelist;

            var whitelistKeys = Object.keys(whitelist);
            function stripUrl(url) {
                try {
                    var uri = new URL(url);
                    return uri.pathname;
                } catch {
                    if (url.indexOf('?') >= 0) {
                        return url.split('?')[0];
                    }

                    return url;
                }
            }

            this.request = function (config) {
                // Remove query string (and for core API, origin)
                let url = stripUrl(config.url);

                // Conversions to query params and request data
                if (whitelistKeys.indexOf(url) > -1) {
                    convertToUTC(whitelist[url], config.params);
                    convertToUTC(whitelist[url], config.data);
                } else {
                    var regexMatch = regexWhitelist.find((x) => x.rx.test(url));
                    if (regexMatch) {
                        convertToUTC(regexMatch.props, config.params);
                        convertToUTC(regexMatch.props, config.data);
                    }
                }

                return config;
            };

            this.response = function (response) {
                var url = stripUrl(response.config.url);

                if (whitelistKeys.indexOf(url) > -1) {
                    convertToLocal(whitelist[url], response.data);
                } else {
                    var regexMatch = regexWhitelist.find((x) => x.rx.test(url));
                    if (regexMatch) {
                        convertToLocal(regexMatch.props, response.data);
                    }
                }

                response.config.headers.pragma = undefined;

                return response;
            };

            function convertToLocal(keys, input) {
                if (!angular.isObject(input)) {
                    return;
                }

                angular.forEach(input, function (value, key) {
                    if (keys.indexOf(key) > -1) {
                        // Convert UTC to local time for the current organisation.
                        if (input[key] === null) {
                            input[key.slice(0, -3)] = null;
                            delete input[key];
                            return;
                        }

                        // handle arrays of dates
                        if (angular.isArray(input[key])) {
                            var outputArray = (input[key.slice(0, -3)] = []);
                            angular.forEach(input[key], function (date) {
                                var result = utcToOrgTimeString(date);

                                outputArray.push(result);
                            });
                        } else {
                            input[key.slice(0, -3)] = utcToOrgTimeString(input[key]);
                        }

                        delete input[key];
                    } else if (angular.isObject(value)) {
                        convertToLocal(keys, value);
                    }
                });
            }

            function convertToUTC(keys, input) {
                if (!angular.isObject(input)) {
                    return;
                }

                angular.forEach(input, function (value, key) {
                    if (keys.indexOf(key) > -1) {
                        if (key == 'orderBy') {
                            // special case for orderBy, do not convert property name to orderByUtc
                            // instead, append Utc to property value if that value is in whitelist.
                            var orderBy = input['orderBy'];
                            if (orderBy && keys.indexOf(orderBy) > -1) {
                                input['orderBy'] = orderBy + 'Utc';
                            }
                            return;
                        }

                        // Convert local time to UTC for the current organisation.
                        if (!input[key]) {
                            input[key + 'Utc'] = null;
                            delete input[key];
                            return;
                        }

                        var isoDate = input[key];
                        if (isoDate instanceof Date) {
                            isoDate = input[key].toISOString();
                        } else if (moment.isMoment(input[key])) {
                            isoDate = input[key].format('YYYY-MM-DDTHH:mm:ss');
                        }

                        // remove trailing Z otherwise Web API controllers will automatically apply time offset to convert to a local time
                        isoDate = isoDate.replace('Z', '');

                        // console.log('Converting ' + isoDate + ' to UTC');
                        input[key + 'Utc'] = utcToOrgTimeString(isoDate, true);
                        delete input[key];
                    } else if (angular.isObject(value)) {
                        convertToUTC(keys, value);
                    }
                });
            }

            function utcToOrgTimeString(inputDate, isRevert = false) {
                if (!inputDate.endsWith('Z')) {
                    inputDate += 'Z';
                }
                let offset = dateTextService.getOrgTimezoneText(new Date(inputDate));

                if (isRevert) {
                    const init = offset[0];
                    const sign = init === '-' ? '+' : '-';
                    offset = sign + offset.slice(1);
                }

                return $filter('date')(
                    inputDate,
                    'yyyy-MM-ddTHH:mm:ss',
                    offset
                );
            }
        },
    ]);
